import { useSearchParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { LineageFloatingNavBar } from '@/components/Lineage/LineageFloatingNavBar';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { MultiProjectPage } from '../MultiProjectPage';
import { NewMultiProjectPage } from '../NewMultiProjectPage';

export const AccountLineagePage = () => {
  const { hasAccountFeature } = useDbtCloudAccount();
  const isCatalogPreviewEnabled = hasAccountFeature('explorerAccountUI');

  const [searchParams] = useSearchParams();
  const { accountName, accountId = 0 } = useDbtCloudAccount();
  const viewType = searchParams.get('view') === 'lineage' ? 'lineage' : 'list';
  return (
    <>
      {!isCatalogPreviewEnabled && (
        <>
          {viewType === 'list' && (
            <LineageFloatingNavBar
              granularity="account"
              view={viewType}
              accountName={accountName}
              accountId={accountId}
            />
          )}
          <div
            className={twMerge('h-full w-full', viewType === 'list' && 'overflow-auto')}
            data-testid="multi-project-page"
          >
            <MultiProjectPage />
          </div>
        </>
      )}
      {isCatalogPreviewEnabled && (
        <div
          className="h-full w-full overflow-y-auto"
          data-testid="new-multi-project-page"
        >
          <NewMultiProjectPage />
        </div>
      )}
    </>
  );
};
